enum StatusCirurgiaEnum {
  NaoRealizada = 'NaoRealizada',
  Realizada = 'Realizada',
}

export default StatusCirurgiaEnum
